import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { DrawerHeader } from '../SideMenu/SideMenuTheme'
import { useSelector } from 'react-redux';
import * as ImIcon from 'react-icons/im'
import Cookies from 'universal-cookie'
import { useNavigate } from 'react-router';
const cookies = new Cookies();


export default function HeaderDrawer({ open, setOpen, handleDrawerOpen, handleDrawerClose, getUserImage }) {

  const sidemenutheme = useSelector(state => state.themeData.sidemenutheme)
  const theme = useSelector(state => state.themeData);
  const maintheme = useSelector(state => state.themeData.maintheme);
  const styleToggleIconeMenu = {
    position: 'absolute',
    top: '10px',
    left: '25px',
    fontWeight: 'bold',
    cursor: 'pointer'
  }
  const navigate = useNavigate()

  return (
    <Box>
      <style>
        {`
          @keyframes rotateBorder {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .instagram-border-container {
            position: relative;
            width: 58px;
            height: 58px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            overflow: hidden;
            transition: all 0.4s ease;
          }
          .instagram-border-container::after {
            content: "";
            position: absolute;
            inset: -50%;
            background: conic-gradient(from 0deg, 
              ${sidemenutheme?.primaryColor || '#74bdcb'}, 
              ${maintheme?.secondaryColor || '#52575D'}, 
              ${sidemenutheme?.secondaryColor || '#74bdcb'}
            );
            animation: rotateBorder 3s linear infinite;
            z-index: 0;
          }
          .instagram-border-inner {
            position: relative;
            width: 52px;
            height: 52px;
            background: ${sidemenutheme?.backgroundColor || '#ffffff'};
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1;
          }
        `}
      </style>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: open ? 'space-between' : 'end',
          alignItems: 'center',
          alignContent: 'center',
          marginBottom: '10px',
          width: '100%',
          height: open ? '175px' : '100px',
          position: 'relative',
        }}
      >
        {open ? <ImIcon.ImArrowRight2 onClick={handleDrawerClose} style={styleToggleIconeMenu} size={24} color={sidemenutheme?.colorblack} /> : <ImIcon.ImArrowLeft2 onClick={handleDrawerOpen} style={styleToggleIconeMenu} size={24} color={sidemenutheme?.colorblack} />}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: open ? 'start' : 'center',
            alignItems: 'center',
            cursor: 'pointer',
            width: '100%',
            transition: "all ease-in-out 5s !important"
          }}
          onClick={() => {
            navigate('/system/profile')
          }}
        // className="hover-style"
        >
          {!open ? (
            <Box className="instagram-border-container shadow-lg">
              <Box className="instagram-border-inner">
                <img src={getUserImage() ? getUserImage() : (theme.images.sidebar)} alt="admin-picture" style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: '50%',
                  objectFit: 'cover',
                  backgroundPosition: 'center center',
                }} />
              </Box>
            </Box>
          ) : (
            <img src={getUserImage() ? getUserImage() : (theme.images.sidebar)} alt="admin-picture" style={{
              width: "100px",
              height: "100px",
              background: "transparent",
              borderRadius: '50%',
              opacity: "1",
              objectFit: 'cover',
              backgroundPosition: 'center center',
              transition: 'all 0.4s ease',
              border: `2px solid ${sidemenutheme?.secondaryColor || '#74bdcb'}`,
            }} />
          )}

          {
            open ?
              <Typography variant='span'
                sx={{
                  textAlign: 'left',
                  font: 'normal normal 19px/22px Cairo-Bold',
                  letterSpacing: ' -1px',
                  color: sidemenutheme?.lightblack,
                  opacity: 1,
                  marginTop: '18px',
                  transition: 'all 0.6s ease'
                }}
              >{cookies.get('account_name')}</Typography> : null
          }
          {
            open ?
              <Typography variant='span'
                sx={{
                  textAlign: "left",
                  font: ' normal normal 15px/20px Cairo-Light',
                  letterSpacing: '0px',
                  color: sidemenutheme?.lightblack,
                  opacity: 1,
                  marginTop: '10px',
                  transition: 'all 0.8s ease'
                }}
              >
                {cookies.get('user_name')}
              </Typography> : null
          }
        </Box>

      </Box>
    </Box>
  )
}
